import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppService } from '../app.service';

export const trainingTypeResolver: ResolveFn<unknown> = () => {
  const appService = inject(AppService);

  return appService.getCodeListsByGroup(
    "TRAINING_TYPE"
  );
};
